import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import ShowActivityRowCard from "./ShowActivityCard";
import { onShowActivity } from "common/signalR";

interface Props {
  showId: number
  config: server.dto.ActivityPanelConfig
}

const ShowActivityPanel = (props: Props) => {
  const { showId, config } = props;

  return <ActivityPanel<server.dto.ShowActivity>
    config={config}
    fetchActivities={(page, perPage) => window.CoreApi.Show.ListActivity({ page, perPage, itemId: showId })}
    renderActivity={(activity) => <ShowActivityRowCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onShowActivity}
    onActivity={() => ({ refreshActivities: true })}
  />;
};

export default ShowActivityPanel;